<template>

    <main class="gmp-page gmp-page--no-newsletter">
        <PL_subpagehero />
        <PL_two_column_text />
        <PL_two_column_fullbleed />

    </main>

</template>


<script>
    import PL_subpagehero from "../../../components/content/market/benefit/PL_subpagehero";
    import PL_two_column_text from "../../../components/content/market/benefit/PL_two_column_text";
    import PL_two_column_fullbleed from "../../../components/content/market/benefit/PL_two_column_fullbleed";


    export default {
        name: 'PL_Benefit',
        components:{
            PL_subpagehero,
            PL_two_column_text,
            PL_two_column_fullbleed,

        }

    }


</script>

<style>



</style>